/* Berserker Breaks — theme.js
   Minimal vanilla JS, no build step required. */

document.addEventListener('DOMContentLoaded', function () {
  initMobileNav();
  initProductGallery();
  initCartQty();
  initAccordions();
});

/* Mobile nav toggle */
function initMobileNav() {
  var toggle = document.querySelector('[data-mobile-nav-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', function () {
    var isOpen = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen);
  });
}

/* Product gallery thumbnail swap */
function initProductGallery() {
  var main = document.querySelector('[data-gallery-main]');
  var thumbs = document.querySelectorAll('[data-gallery-thumb]');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var newSrc = thumb.getAttribute('data-full-src');
      if (!newSrc) return;
      main.src = newSrc;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
}

/* Cart line item quantity steppers */
function initCartQty() {
  document.querySelectorAll('[data-qty-wrapper]').forEach(function (wrapper) {
    var input = wrapper.querySelector('input[type="number"]');
    var minus = wrapper.querySelector('[data-qty-minus]');
    var plus = wrapper.querySelector('[data-qty-plus]');
    if (!input) return;
    if (minus) {
      minus.addEventListener('click', function () {
        var val = Math.max(0, parseInt(input.value || '0', 10) - 1);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        var val = parseInt(input.value || '0', 10) + 1;
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });
}

/* Keep only one product accordion item open at a time (optional, non-essential) */
function initAccordions() {
  var group = document.querySelector('[data-accordion-group]');
  if (!group) return;
  var items = group.querySelectorAll('details');
  items.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open) {
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      }
    });
  });
}
